<template>
  <ul class="searchable__radio">
    <li class="searchable__radio__item" v-for="searchable in searchables"
        :key="searchable.slug">
      <input @change="pushToStore" type="radio" :id="searchable.slug"
             :value="searchable.slug"
             v-model="picked">
      <label :for="searchable.slug">{{ searchable.title }}</label>
    </li>
  </ul>
</template>
<script>
import {computed, ref, watchEffect} from 'vue'
import {useStore} from "vuex";

export default {
  name: 'SearchableRadioList',
  setup() {
    const picked = ref('')
    const store = useStore()
    const activeSearchables = computed(() => store.getters.activeSearchables)
    const searchables = computed(() => store.getters.data.searchables)
    watchEffect(() => {
      if (activeSearchables.value[0]) {
        picked.value = activeSearchables.value[0]
      }
    })

    //Find active searchable when using radio button
    const pushToStore = () => store.dispatch('selectOneSearchable', {...searchables.value?.find(item => item.slug === picked.value)})

    return {
      picked, searchables, pushToStore
    }
  }
}
</script>
